import {Component, Input, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../subscribe/subscribe.component";

@Component({
    selector: 'app-team',
    standalone: true,
    templateUrl: './team.component.html',
    imports: [
        RouterLink,
        SubscribeComponent
    ],
    styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

    @Input() isOnHome: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
